<script setup lang="ts">
// provideHeadlessUseId(() => useId());
useAuthModalsStore();

const i18nHead = useLocaleHead();
useHead(() => ({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs.lang,
  },
}));

useSeoMeta({
  titleTemplate: (title?: string) =>
    `${title ? title + " | " : ""}GFAL Marketplace`,
});

useServerSeoMeta({
  robots: "index, follow",
});
</script>

<template>
  <div>
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <LazyModalContainer />
  </div>
</template>
